export default "__VITE_ASSET__AEhxWh8K__"